import { motion } from "framer-motion";
import { Shield, CheckCircle, Lock, Star } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";

export function ComplianceSection() {
  const { language } = useLanguage();

  const content = {
    fr: {
      title: "Confiance & Conformité",
      subtitle: "Déjà adopté par les professionnels de proximité pour simplifier la collecte d'avis.",
      items: [
        {
          icon: Shield,
          title: "Conforme Google API",
          desc: "Conçu pour respecter les politiques Google API (Limited Use)",
        },
        {
          icon: CheckCircle,
          title: "Centralisation Multi-Plateforme",
          desc: "Google, Facebook, Yelp, TripAdvisor, Trustpilot",
        },
        {
          icon: Lock,
          title: "RGPD & CCPA",
          desc: "Données chiffrées et protégées",
        },
      ],
    },
    en: {
      title: "Trust & Compliance",
      subtitle: "Trusted by local businesses to simplify review collection.",
      items: [
        {
          icon: Shield,
          title: "Google API Compliant",
          desc: "Designed to comply with Google API policies (Limited Use)",
        },
        {
          icon: CheckCircle,
          title: "Multi-Platform Centralization",
          desc: "Google, Facebook, Yelp, TripAdvisor, Trustpilot",
        },
        {
          icon: Lock,
          title: "GDPR & CCPA Ready",
          desc: "Encrypted and protected data",
        },
      ],
    },
  };

  const t = content[language];

  return (
    <section className="py-16 bg-gradient-to-br from-slate-50 to-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-3">
            {t.title}
          </h2>
          <p className="text-muted-foreground flex items-center justify-center gap-2">
            <Star className="text-warning fill-warning" size={18} />
            {t.subtitle}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {t.items.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="flex items-center gap-4 p-5 bg-white rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center flex-shrink-0">
                <item.icon className="text-accent" size={24} />
              </div>
              <div>
                <h3 className="font-semibold text-foreground text-sm md:text-base">
                  {item.title}
                </h3>
                <p className="text-xs text-muted-foreground">{item.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
